export const PREDEFINED_PRICING_TIERS_FEATURE_KEY = 'predefinedPricingTiers';
